import loginGeneral from '@/store/modules/login/general';

export default {
  loginGeneral,
};
